import { forwardRef, useImperativeHandle, useRef } from "react";
import { SplitButton } from "primereact/splitbutton";
import { Button } from "primereact/button";
import ChangeStudentStatusModal from "../../../trainings/students/models/ChangeStudentStatusModal";

/**
 * Footer action of a registration step: a primary action with an optional
 * dropdown of secondary actions. Items with `visible: false` are removed.
 * Also hosts the status change modal, opened through `ref.changeStatus(status)`.
 */
const RegistrationStepActions = forwardRef(({ primary, items = [], currentStudent, schoolId, trainingId, callback }, ref) => {
    const changeStatusModalRef = useRef(null);

    useImperativeHandle(ref, () => ({
        changeStatus: (status) => changeStatusModalRef.current?.show(() => callback?.(), { status }),
    }));

    const visibleItems = items
        .filter((item) => item.visible !== false)
        .map(({ visible, ...item }) => item);

    const commonProps = {
        label: primary?.label,
        icon: primary?.icon,
        severity: primary?.severity,
        outlined: primary?.outlined,
        className: "w-full mt-3",
    };

    return (
        <>
            {primary && (visibleItems.length > 0 ? (
                <SplitButton
                    {...commonProps}
                    onClick={primary.onClick}
                    buttonProps={{ disabled: !!primary.disabled }}
                    menuButtonProps={{ disabled: visibleItems.every((item) => item.disabled), "aria-label": "Autres actions" }}
                    model={visibleItems}
                />
            ) : (
                <Button {...commonProps} onClick={primary.onClick} disabled={!!primary.disabled} />
            ))}
            <ChangeStudentStatusModal ref={changeStatusModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
        </>
    );
});

export default RegistrationStepActions;
